
const digest = 'a734f5898db2a8f74f9eb43ac57b8fe17059071c5b78f644b30e2ce9181b11c9';
const classes = {"wrapper":"_wrapper_x1uw5_1"};
const css = `._wrapper_x1uw5_1 {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  